import { BFF_BASE_URL } from "../../../api/client";

/**
 * Opens the Deal Summary PDF for the given approval in a new browser tab.
 * The BFF endpoint (GET /api/v1/workbench/{approvalId}/deal-summary/pdf)
 * returns the raw PDF with `Content-Type: application/pdf` and
 * `Content-Disposition: inline`, so the browser renders it natively —
 * no client-side fetching/decoding is needed. Auth is handled via the
 * oauth2-proxy session cookie, which is sent automatically since the BFF
 * is same-origin.
 * @param {string} approvalId - The approval/deal ID.
 */
export function downloadDealSummaryPdf(approvalId: string): void {
  const url = `${BFF_BASE_URL}/api/v1/workbench/${encodeURIComponent(approvalId)}/deal-summary/pdf`;
  window.open(url, "_blank");
}
